const thousandSeparator = (number, currency = "ت") => {
  const n = Number(number || 0)

  return `${Number(Math.round(Math.abs(n))).toLocaleString(undefined)}${n >= 0 ? "" : "-"} ${currency}`
}

export default thousandSeparator